import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const UnauthorizedComponent = () => {
    const navigate = useNavigate();

    return (
        <Box 
            sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh', 
                textAlign: 'center' 
            }}
        >
            <Typography variant="h4" color="error" gutterBottom>
                Unauthorized Access
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
                You do not have permission to access this page.
            </Typography>
            <Button variant="contained" color="primary" onClick={() => navigate('/')}>
                Go to Login
            </Button>
        </Box>
    );
};

export default UnauthorizedComponent;
